<template>
  <div>
    <a-drawer
      title="Create a new resource"
      width="60%"
      @close="onClose"
      :visible="isDrawerVisible"
      :wrapStyle="{height: 'calc(100% - 108px)',overflow: 'auto',paddingBottom: '108px'}"
    >
    <a-spin size="large" :spinning="loading">
      <a-form :form="form" :layout="formLayout" style="margin-top:1em;" class="create_tenant">
        <a-text-field
          varName="name"
          varLabel="Resource Name"
          :varRequired="true"
          :formLayout="formLayout"
          :size="size"
        />
        <a-text-area-field
          varName="description"
          varLabel="Resource Description"
          :varRequired="true"
          :formLayout="formLayout"
          :size="size"
        />
            <a-url-field
              varName="endpoint"
              varLabel="Endpoint"
              :varRequired="false"
              :formLayout="formLayout"
              :size="size"
              icon="api"
              description="A valid endpoint URL with protocol - http:// or https://."
            />
            <a-divider><mark>Provide identifier or endpoint</mark></a-divider>
            <a-slug-field
              varName="identifier"
              varLabel="Identifier"
              :varRequired="false"
              :formLayout="formLayout"
              :size="size"
              description="Containing only letters, numbers, hyphens (a valid slug)."
            />
        <a-submit-button
          @submit="handleSubmit"
          :formLayout="formLayout"
          btn_text="Create Resource"
          styled="margin-top:0.5em;"
        />
        <a-alert v-if="error" :message="error" type="error" closable style="margin-top: 1em;" @close="onCloseError"/>
      </a-form>
    </a-spin>
    </a-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      formLayout: "vertical",
      size: "large",
      loading: false,
      error: false
    };
  },
  methods: {
    onCloseError(e) {
      console.log(e)
      this.error=false;
    },
    onClose() {
      this.$store.dispatch("ui/hideDrawer", {
        drawer_name: "create_resource"
      });
    },
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            if (!values['identifier'] && !values['endpoint']) {
              this.error = "You must provide an identifier or an endpoint for the resource.";
              throw new TypeError(this.error);
            }
            this.loading = true;
            await this.$store.dispatch("tenant/createItem", {
              endpoint: "resources",
              data: values
            });
            this.loading = false;
            await this.$store.dispatch("ui/hideDrawer", {
              drawer_name: "create_resource"
            });
            await this.$store.dispatch("tenant/getItems", {
              endpoint: "resources"
            });
            await this.$notification.open({
              message: "New resource created!",
              description: "Please configure your new resource.",
              icon: (
                <a-icon
                  type="check-circle"
                  theme="filled"
                  style="color: green"
                />
              )
            });
          } catch (error) {
            console.error(error);
            this.loading = false;
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    }
  },
  computed: {
    isDrawerVisible() {
      return this.$store.state.ui.create_resource;
    }
  }
};
</script>
